import { MainPropertyType, isUndefined, schTkv2PairedCostSettings } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import React from 'react';

import {
  selectAdjustmentFeatures,
  selectCompAdjustments,
} from '../../redux/features/selectors/adjustmentSelectors.ts';
import {
  selectAdjustmentSettings,
  selectCompSequence,
  selectPropertyType,
} from '../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { PairedCostAdjustmentSummaryTable } from '../summaryV2/PairedCostAdjustmentSummary/PairedCostAdjustmentSummaryTable.tsx';
import { AdjustmentsModalContent } from './AdjustmentsModalContent.tsx';
import { ADJUSTMENT_LABELS } from './consts.ts';
import { AdjustmentsModuleTitle } from './internal/AdjustmentsModuleTitle.tsx';

function _AdjustmentsModule() {
  const compSequence = useAppSelector(selectCompSequence);
  const subject = useAppSelector((state) => selectAdjustmentFeatures(state, 'subject'));
  const comps = useAppSelector(selectCompAdjustments);
  const adjustmentSettings = useAppSelector(selectAdjustmentSettings);
  const mainPropertyType = useAppSelector((state) => selectPropertyType(state));
  if (
    isUndefined(subject) ||
    isUndefined(comps) ||
    isUndefined(adjustmentSettings) ||
    isUndefined(mainPropertyType)
  ) {
    return null;
  }
  // We want to use the order / subject property type here since the
  // adjustment table is defined for all properties from subject -> comps
  const propertyTypeSet = new Set<MainPropertyType>([mainPropertyType]);

  return (
    <Flex height="100%" width="100%" flexDirection="column" paddingLeft="1.5rem">
      <AdjustmentsModuleTitle />
      <PairedCostAdjustmentSummaryTable
        pairedCostVersion="2.0"
        renderModalContent={(adjType) => <AdjustmentsModalContent adjType={adjType} />}
        compSequence={compSequence}
        subject={subject}
        comps={comps}
        adjustmentLabels={ADJUSTMENT_LABELS}
        pairedCostSettings={schTkv2PairedCostSettings.parse(adjustmentSettings)}
        savePairedCostSettings={async () => {
          // Unused
        }}
        propertyTypeSet={propertyTypeSet}
      />
    </Flex>
  );
}

export const AdjustmentsModule = React.memo(_AdjustmentsModule);
